module.exports = "<app-header></app-header>\n<ng-content></ng-content>\n<app-footer></app-footer>\n"